const initialValues = {
  name: "",
  height: 500,
  width: 800,
  background_color: "#ffffff",
  background_image: "",
};

export default initialValues;
